import Rollbar from 'src/analytics/rollbar';

type EventData = {
  eventType: 'EVENT';
  eventName: string;
  eventRevenue?: number;
  eventRevenueCurrency?: string;
  eventValue?: Record<string, any>;
};
interface AppsFlyer {
  (command: 'pba', action: 'setCustomerUserId', value: string): void;
  (command: 'pba', action: 'event', value: EventData): void;
}

declare global {
  interface Window {
    AF?: AppsFlyer;
  }
}

export const setAppsFlyerCUID = async (userId: string | undefined) => {
  if (!userId || !window.AF) return;

  try {
    window.AF('pba', 'setCustomerUserId', userId);
  } catch (error) {
    Rollbar.trackError('appsflyer-cuid', error, userId);
  }
};

export const trackAFEvent = async (data: EventData) => {
  if (!window.AF) return;
  try {
    window.AF('pba', 'event', data);
  } catch (error) {
    Rollbar.trackError('Error tracking AF event', error, data);
  }
};
